import { decodeJwt } from "jose";
export const decode = (token) => {
    try {
        return decodeJwt(token);
    }
    catch (_a) {
        return null;
    }
};
